import { Wrench } from 'lucide-react'
import { useMaintenance } from '@/context/MaintenanceContext'

export function MaintenanceOverlay() {
	const { status } = useMaintenance()

	if (!status.overlay_enabled) return null

	const message =
		status.message?.trim() ||
		'Modelmatic is temporarily unavailable for scheduled maintenance. Please try again shortly.'

	return (
		<div
			className="fixed inset-0 z-[140] flex flex-col items-center justify-center bg-background px-6 text-center"
			role="alertdialog"
			aria-modal="true"
			aria-labelledby="maintenance-overlay-title"
			aria-describedby="maintenance-overlay-description"
		>
			<div className="flex max-w-lg flex-col items-center gap-4">
				<div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 text-amber-700">
					<Wrench className="h-8 w-8" aria-hidden />
				</div>
				<h1 id="maintenance-overlay-title" className="text-2xl font-semibold text-foreground">
					Scheduled maintenance
				</h1>
				<p id="maintenance-overlay-description" className="text-sm text-muted-foreground">
					{message}
				</p>
			</div>
		</div>
	)
}
